import DailyMockBannerFormPage from "./DailyMockBannerFormPage";

export default function DailyMockBannerEdit() {
  return (
    <DailyMockBannerFormPage
      mode="edit"
      pageTitle="Edit Daily Mock Banner"
      breadcrumbTitle="Edit Daily Mock Banner"
      backPath="/daily-mock-banner"
      successMessage="Daily mock banner updated successfully"
    />
  );
}
